import { Bar } from "react-chartjs-2"
import uniqolor from "uniqolor"
import { useMemo } from "react";

interface ChartDataItem {
    key:string,
    label: string;        // Judul chart (dan judul di axis Y)
    labels: string[];     // Label sumbu X (misalnya: lokasi)
    totalList: number[];  // Nilai bar chart (jumlah per label)
}

export function SummaryBar({ key, label, labels, totalList }: ChartDataItem): JSX.Element {
    const backgroundColors = useMemo(() =>
        labels.map(label => uniqolor(label, { format: "rgb" }).color),
    [labels]);

    return (
        <div key={key} className="w-full h-[300px]">
            <Bar
                className="border"
                title={label}
                data={{
                    labels,
                    datasets: [
                        {
                            backgroundColor: backgroundColors,
                            data: totalList,
                            maxBarThickness: 40,
                        }
                    ]
                }}
                options={{
                    maintainAspectRatio: false,
                    responsive: true,
                    plugins: {
                        datalabels: { display: false },
                        legend: { display: false },
                        title: {
                            display: true,
                            text: label
                        }
                    },
                    scales: {
                        x: {
                            beginAtZero: true,
                            title: {
                                display: true,
                                text: "Location"
                            }
                        },
                        y: {
                            beginAtZero: true,
                            title: {
                                display: true,
                                text: label
                            }
                        }
                    }
                }}
            />
        </div>
    )
}
